import React from 'react';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdDeleteOutline } from 'react-icons/md';

const HealthCondition = ({ value, setFieldValue }) => {
  const addHealthCondition = () => {
    setFieldValue('incompatible_medical_conditions', [
      ...value.incompatible_medical_conditions,
      { value: '' }
    ]);
  };

  const removeHealthCondition = (idx) => {
    const updatedData = value.health_conditions.filter((_, i) => i !== idx);
    setFieldValue('incompatible_medical_conditions', updatedData);
  };
  const updateHealthConditions = (idx, field, val) => {
    const updated = [...value.incompatible_medical_conditions];
    updated[idx] = { ...updated[idx], [field]: val };
    setFieldValue('incompatible_medical_conditions', updated);
  };

  return (
    <div>
      <>
        {value.incompatible_medical_conditions &&
          value.incompatible_medical_conditions.map((item, idx) => (
            <div
              key={idx}
              className="mb-3"
              style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center'
              }}
            >
              <input
                type="text"
                name="value"
                placeholder="Enter Incompatible Medical Condition"
                value={item?.value}
                className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
                onChange={(e) => {
                  updateHealthConditions(idx, 'value', e.target.value);
                }}
              />
              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center'
                }}
              >
                {value.incompatible_medical_conditions.length >= 2 && (
                  <div onClick={() => removeHealthCondition(idx)}>
                    <MdDeleteOutline size={20} className="text-red-500" />
                  </div>
                )}

                <div onClick={addHealthCondition}>
                  <IoMdAddCircleOutline size={20} color="#549a9a" />
                </div>
              </div>
            </div>
          ))}
      </>
    </div>
  );
};

export default HealthCondition;
